@let notificationItem = notification();

<flx-workspace-env-type-tag
  [envType]="notificationItem.workspaceType"
  [name]="notificationItem.workspaceType"
  data-testid="notification-env-tag"
/>

<div class="flex items-center min-w-0 gap-1 text-xs/[18px] text-neutral-500">
  <div
    [pTooltip]="notificationItem.workspaceName"
    [showDelay]="TOOLTIP_DEFAULT_DELAY"
    [showOnEllipsis]="true"
    class="flex-1 max-w-fit truncate"
    data-testid="notification-workspace-name"
    tooltipPosition="top"
    tooltipStyleClass="text-xs"
    tooltipZIndex="2004"
  >
    {{ notificationItem.workspaceName }}
  </div>
  /
  <i
    [class]="applicationIcon()"
    class="shrink-0 text-base/4"
    data-testid="notification-application-icon"
  ></i>
  <div
    [pTooltip]="notificationItem.appName"
    [showDelay]="TOOLTIP_DEFAULT_DELAY"
    [showOnEllipsis]="true"
    class="flex-1 max-w-fit truncate"
    data-testid="notification-application-name"
    tooltipPosition="top"
    tooltipStyleClass="text-xs"
    tooltipZIndex="2004"
  >
    {{ notificationItem.appName }}
  </div>
</div>
